/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

export enum NagraPlayerEvent {
  ERROR = 'error',
  ENDED = 'ended',
  LOADED_DATA = 'loadeddata',
  LOADED_METADATA = 'loadedmetadata',
  LOAD_START = 'loadstart',
  PAUSE = 'pause',
  PLAY = 'play',
  PLAYING = 'playing',
  WAITING = 'waiting',
  DURATION_CHANGED = 'durationchange',
}

export enum TextTrackKind {
  SUBTITLES = 'subtitles',
  SUBTITLES_HARD_OF_HEARING = 'descriptions',
}

export enum AudioTrackKind {
  AUDIO_DESCRIPTIONS = 'descriptions',
}

export enum TextTrackMode {
  SHOWING = 'showing',
  DISABLED = 'disabled',
}
